var map = {
	"./11.jpg": 224,
	"./16.jpg": 225,
	"./3.jpg": 197,
	"./4.jpg": 329,
	"./7.jpg": 330,
	"./Teams/Club-puebla.png": 547,
	"./Teams/Club_Tijuana.png": 548,
	"./Teams/Fútbol_Club_Atlas.png": 549,
	"./Teams/Santos6estrellas.png": 550,
	"./Teams/club-america.png": 551,
	"./Teams/necaxa.png": 552,
	"./Teams/tigres.png": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;